/* eslint-disable react/no-array-index-key */

import { createContext, memo } from 'react';
import type { ProductListPartialViewModel } from 'autogen/swagger/all';
import { useGetProductListPartialForFilterMenu } from 'components/shared/productList/shared/hooks/useGetProductListPartialQuery';
import FilterMenu from './FilterMenu';
import RootFilterMenu from './RootFilter/RootFilterMenu';

export const FilterMenuDataContext = createContext({} as ProductListPartialViewModel);

const FilterMenuRenderer = ({ model: initialModel }: { model: ProductListPartialViewModel }) => {
    const { data } = useGetProductListPartialForFilterMenu(initialModel);
    const model = data || initialModel;
    const { productList } = model;
    const { filters, activeFilterValues } = productList;
    const aboveFilters = filters.filter((filter) => filter.attribute.location === 'Above');

    return (
        <FilterMenuDataContext.Provider value={model}>
            {/* The all Filters Menu aka. Root filter menu */}
            <RootFilterMenu filters={aboveFilters} activeFilterValues={activeFilterValues} />

            {/* The specific filters Menus (brand, price, etc) */}
            {aboveFilters.map((filter, i) => (
                <FilterMenu key={i} model={filter} />
            ))}
        </FilterMenuDataContext.Provider>
    );
};

export default memo(FilterMenuRenderer);
